// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Gp0j","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1VMZQ","obliqueLine":"membershipbadge_obliqueLine__2mtG7"};